import React, {Component} from "react";
import styled, {keyframes} from "styled-components";
import {WhenInView} from "../Tools/WhenInView";
import {Check} from "react-feather";
import {
  Contain,
  HugeTitle,
  InfoParagraph,
  Margin,
  primary,
  ThinLine,
  SmallMargin,
  LargeTitle,
  gray,
  lighter,
  SmallTitle,
  ContainWPadding,
  SplashTitle,
  SplashTitleMobile,
  AttentionTitle
} from "../Tools/Variables";
import {InterestedBody} from "../Global/MailChimpModal";

const Wrapper = styled.div `
  text-align: center;
`;

class Interested extends Component {
  render() {
    return (
      <div>
        <Wrapper>
          <div
            style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
          }}>

            <SmallMargin/>
            <SmallMargin/>

            <AttentionTitle
              style={{
              maxWidth: 800,
              margin: '10vw 0'
            }}>
              <SmallTitle>INTRESSEANMÄLAN</SmallTitle>
              <SmallMargin/>

              Anslut till sängrevolutionen</AttentionTitle>

            <SmallMargin/>
            <SmallMargin/>
          </div>

          <WhenInView>
            {({isInView}) => (
              <div
                style={{
                background: lighter,
                transition: "1s ease-in-out",
                maxHeight: isInView
                  ? 800
                  : 15,
                overflow: "hidden"
              }}>
                <ContainWPadding>
                  <SmallMargin/>

                  <SmallMargin/>
                  <div
                    style={{
                    maxWidth: 800,
                    margin: "0 auto",
                    textAlign: "left"
                  }}>
                    <InterestedBody
                      page={'startpage'}
                      setHideContactModal={this.props.setHideContactModal}/>
                  </div>
                  <SmallMargin/>
                  <SmallMargin/>
                </ContainWPadding>
              </div>
            )}
          </WhenInView>
        </Wrapper>
      </div>
    );
  }
}

export default Interested;



// WEBPACK FOOTER //
// ./src/Home/Interested.js